import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    const flashEls = document.getElementsByClassName('flash')
    while(flashEls.length > 0) {
      flashEls[0].parentNode.removeChild(flashEls[0])
    }
  }
}